import { displayShortDate } from '../../utils/Format/Format';
import { sortByTitle } from '../../utils/manager-utils';

export const investmentTeamUtil = (gqlResult) => {
    if (!gqlResult) return null;
    const { mutualFundManagers } =
        gqlResult.exchangeTradedFund || gqlResult.mutualFund;

    const sortedManagers = sortByTitle(mutualFundManagers);

    const data = sortedManagers.map((ele) => ({
        name: ele.managerName,
        managedSince: displayShortDate(ele.managedFundSinceDate),
        position: ele.title, // 'Fund Manager', // Extend this after MVP if including whole team
        education: ele.educationText,
        joinedDate: displayShortDate(ele.joinedFirmDate),
        headshot:
            !ele.headShots2 ||
            ele.headShots2.find((e) => e.width === 256 && e.height === 384)
    }));

    return { data };
};
